import { Component, OnInit, ViewChild } from "@angular/core";
import { DigitalIdEmailLogComponent } from "./digital-id-email-log/digital-id-email-log.component";

@Component({
	selector: "app-student-digital-id-registration",
	templateUrl: "./student-digital-id-registration.component.html",
	styleUrls: ["./student-digital-id-registration.component.css"],
})
export class StudentDigitalIdRegistrationComponent implements OnInit {
	constructor() {}

	ngOnInit(): void {}

	///////////////////////////////////////////////////////////////////////////
	// Data
	///////////////////////////////////////////////////////////////////////////

	SelectMode: string = "Manual"; //Manual | Batch
	EmailLogExpand: boolean = false;

	@ViewChild(DigitalIdEmailLogComponent)
	emailRef: DigitalIdEmailLogComponent;

	///////////////////////////////////////////////////////////////////////////

	onEmailRefresh() {
		this.EmailLogExpand = true;
		this.emailRef.onRefresh();
	}
}
